import React from 'react'
import { Typography, Stack, Box, useMediaQuery, useTheme } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useGetLanguageMapperGif } from '../../guided-tour-gifs/use-get-language-gif'

/** Tariff 3 dot menu options step */
export const TariffsMenuStep: React.FC = () => {
  const { breakpoints } = useTheme()
  const isMobile = useMediaQuery(breakpoints.down('sm'))
  const { t } = useCustomTranslation()

  const { tariffMenuOptionGif } = useGetLanguageMapperGif()

  return (
    <Stack direction="column">
      <Typography>{t('emobility.tour.tariff-menu-options')}</Typography>

      <Box mt={4}>
        <Box component={'img'} width={isMobile ? 200 : 300} src={tariffMenuOptionGif} />
      </Box>
    </Stack>
  )
}
